<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <a href="/teacher/tasks/all"><i class="fas fa-tasks mr-1"></i> Atividades</a> / <span class="text-muted">Criar Atividade</span>
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <div class="container mb-4">
            <div class="row">
                <div class="col-sm-6 mx-auto">
                    <b-overlay :show="loading" rounded="sm">
                        <b-card>
                            <b-form @submit="submit" @submit.stop.prevent>

                                <!-- Field -->
                                <b-form-group
                                    label="Nome da Atividade"
                                    description="Qual é o nome da atividade que os alunos irão fazer ?">
                                    <!-- Input -->
                                    <b-form-input
                                        v-model="form.name"
                                        :state="hasErrors('name', errors)"
                                    ></b-form-input>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="name" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Corretor"
                                    description="Quem é o corretor dessa atividade ?">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="teacher"
                                        :options="teachers"
                                        :loading="loading"
                                        track-by="id"
                                        label="name"
                                        placeholder=""
                                        @select="(value) => this.form.teacher_id = value.id"
                                        @remove="() => this.form.teacher_id = null"
                                        tag-placeholder="Filtrar Corretor"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                        <span slot="noResult">
                                            Ops! Nenhum resultado encontrado na pesquisa :(
                                        </span>

                                        <span slot="noOptions">
                                            Não há corretor disponível para exibir :(
                                        </span>
                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="teacher_id" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Turma"
                                    description="Qual é a turma que vai participar dessa atividade ?">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="group"
                                        :options="groups"
                                        :loading="loading"
                                        track-by="id"
                                        label="name"
                                        placeholder=""
                                        @select="(value) => this.form.group_id = value.id"
                                        @remove="() => this.form.group_id = null"
                                        tag-placeholder="Filtrar Turma"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                        <span slot="noResult">
                                            Ops! Nenhum resultado encontrado na pesquisa :(
                                        </span>

                                        <span slot="noOptions">
                                            Não há turmas disponíveis para exibir :(
                                        </span>
                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="group_id" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    v-if="! blockThemes"
                                    label="Modo de Tema"
                                    description="Qual o modo de tema que deseja para essa atividade ? Específico ou Livre ?">

                                    <!-- Input -->
                                    <b-form-radio v-model="form.type" name="type" value="theme">
                                        Quero indicar um tema específico para a atividade.
                                    </b-form-radio>
                                    <b-form-radio v-model="form.type" name="type" value="mode">
                                        Quero um tema livre para a atividade.
                                    </b-form-radio>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="type" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    v-if="form.type === 'theme'"
                                    label="Tema"
                                    description="Qual é o tema dessa atividade ?">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="theme"
                                        :options="themes"
                                        :loading="loading"
                                        track-by="id"
                                        label="title"
                                        placeholder=""
                                        @select="(value) => this.form.theme_id = value.id"
                                        @remove="() => this.form.theme_id = null"
                                        tag-placeholder="Filtrar Tema"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                        <span slot="noResult">
                                            Ops! Nenhum resultado encontrado na pesquisa :(
                                        </span>

                                        <span slot="noOptions">
                                            Não há temas disponíveis para exibir :(
                                        </span>
                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="theme_id" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    v-if="form.type === 'mode'"
                                    label="Modo de Correção"
                                    description="Qual é o modo de correção dessa atividade ?">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="mode"
                                        :options="modes"
                                        :loading="loading"
                                        track-by="id"
                                        label="name"
                                        placeholder=""
                                        @select="(value) => this.form.mode_id = value.id"
                                        @remove="() => this.form.mode_id = null"
                                        tag-placeholder="Filtrar Modo de Correção"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                        <span slot="noResult">
                                            Ops! Nenhum resultado encontrado na pesquisa :(
                                        </span>

                                        <span slot="noOptions">
                                            Não há modos de correções disponíveis para exibir :(
                                        </span>
                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="mode_id" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Data de Início"
                                    description="A partir de que data e hora os alunos podem enviar a redação da atividade ?">

                                    <div class="form-row">
                                        <div class="col-sm-7">
                                            <b-form-datepicker
                                                v-model="form.from"
                                                label-no-date-selected="Nenhuma data selecionada ..."
                                                locale="pt-BR">
                                            </b-form-datepicker>

                                            <!-- Error -->
                                            <has-errors :errors="errors" name="from" />
                                        </div>
                                        <div class="col-sm-5">
                                            <b-form-timepicker
                                                v-model="form.from_time"
                                                label-close-button="Fechar"
                                                label-reset-button="Limpar"
                                                locale="pt-BR">
                                            </b-form-timepicker>

                                            <!-- Error -->
                                            <has-errors :errors="errors" name="from_time" />
                                        </div>
                                    </div>
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Data de Fim"
                                    description="Qual é a data e hora máxima para envio da atividade ?">

                                    <div class="form-row">
                                        <div class="col-sm-7">
                                            <b-form-datepicker
                                                v-model="form.to"
                                                label-no-date-selected="Nenhuma data selecionada ..."
                                                label-reset-button="Limpar"
                                                :reset-button="true"
                                                locale="pt-BR">
                                            </b-form-datepicker>

                                            <!-- Error -->
                                            <has-errors :errors="errors" name="to" />
                                        </div>
                                        <div class="col-sm-5">
                                            <b-form-timepicker
                                                v-model="form.to_time"
                                                label-close-button="Fechar"
                                                label-reset-button="Limpar"
                                                :reset-button="true"
                                                locale="pt-BR">
                                            </b-form-timepicker>

                                            <!-- Error -->
                                            <has-errors :errors="errors" name="to_time" />
                                        </div>
                                    </div>

                                </b-form-group>

                                <b-form-group>
                                    <b-form-checkbox
                                        id="notify_students"
                                        name="notify_students"
                                        v-model="form.notify_students"
                                        :value="true"
                                    >
                                        Notificar Alunos da Turma na data do Início da atividade
                                    </b-form-checkbox>
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    v-if="taskDocuments"
                                    label="Envie o Material Complementar"
                                    description="Anexe arquivos que vão ajudar o seu aluno na resolução da atividade.">

                                    <b-form-file
                                        ref="fileDocuments"
                                        @input="loadDocuments"
                                        placeholder=""
                                        browse-text="Procurar"
                                        no-drop
                                    ></b-form-file>
                                </b-form-group>

                                <div v-if="taskDocuments" class="mb-3 row">
                                    <div v-for="(documentItem, key) in form.documents" :key="documentItem.id" class="col-sm-12 d-flex">
                                        <div class="text-muted">
                                            <i class="fas fa-file mr-2"></i>
                                            {{ documentItem.name }}
                                        </div>
                                        <div class="ml-3 text-right">
                                            <a :href="documentItem.preview" target="_blank">
                                                Ver Prévia
                                            </a>

                                            <a href="javascript:void(1);" @click="removeDocument(key)" class="text-danger ml-2">
                                                Remover
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <b-alert :show="loadingDocument" variant="info">
                                    <b-spinner class="mr-2" size="sm"></b-spinner>
                                    Salvando arquivo ....
                                </b-alert>

                                <!-- Submit -->
                                <b-button type="submit" variant="primary" :disable="loading">
                                    {{ task ? 'Duplicar Atividade' : 'Criar Atividade' }}
                                </b-button>

                                <!-- Cancel -->
                                <a href="/teacher/tasks/all" class="ml-2 btn btn-outline-secondary">
                                    Cancelar
                                </a>
                            </b-form>
                        </b-card>
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['teachers', 'groups', 'themes', 'modes', 'blockThemes', 'taskDocuments','task'],
    data() {
        return {
            loading: false,
            loadingDocument: false,
            errors: {},
            form: {
                teacher_id: null,
                group_id: null,
                type: 'mode',
                theme_id: null,
                mode_id: null,
                name: null,
                from: this.$moment().format('YYYY-MM-DD'),
                from_time: this.$moment().format('HH:mm:00'),
                notify_students: null,
                to: null,
                to_time: null,
                documents: []
            },
            teacher: null,
            group: null,
            theme: null,
            mode: null,
        }
    },
    watch: {
        'form.type': function (type) {
            if (type === 'theme') {
                this.form.mode_id = null;
                this.mode = null;
            }
            if (type === 'mode') {
                this.form.theme_id = null;
                this.theme = null;
            }
        },
    },
    created(){
        if(this.task){
            this.hasTask()
        }
    },
    methods: {
        hasTask(){
            this.form.name = this.task.name;
            this.form.teacher_id = this.task.teacher_id;
            this.form.group_id = this.task.group_id;

            this.form.from = this.$moment(this.task.from).format('YYYY-MM-DD');
            this.form.from_time = this.$moment(this.task.from).format('HH:mm:00');

            this.form.to = this.$moment().format('YYYY-MM-DD');
            //this.form.to_time = this.$moment(this.task.to).format('HH:mm:00');

            if(this.task.mode_id){
                this.form.type = 'mode';
                this.form.mode_id = this.task.mode_id;
                this.mode = this.modes.find(mode => mode.id == this.task.mode_id);

            }
            if(this.task.theme_id){
                this.form.type = 'theme';
                this.form.theme_id = this.task.theme_id;
                this.theme = this.themes.find(theme => theme.id == this.task.theme_id);

            }

            this.teacher = this.teachers.find(teacher => teacher.id == this.task.teacher_id);
            this.group = this.groups.find(group => group.id == this.task.group_id);
        },

        submit() {
            this.loading = true;
            axios.post('/teacher/tasks', {
                ...this.form,
                documents: this.form.documents.map((item) => {
                    return item.id
                })
            })
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        async loadDocuments() {
            for (let index = 0; index < this.$refs.fileDocuments.files.length; index++) {
                const file = this.$refs.fileDocuments.files[index];
                if (file.size < 52428800) {
                    await this.uploadDocument(this.$refs.fileDocuments.files[index])
                } else {
                    alert('O arquivo ' + file.name + ' é muito grande. O tamanho máximo permitido é 50MB.')
                }
            }
        },

        async uploadDocument(inputFile) {

            this.loadingDocument = true;

            let formData = new FormData();
            formData.append('document', inputFile)

            await axios.post('/teacher/task-documents', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((result) => {
                    let response = result.data.data;

                    if (response.document) {
                        this.form.documents.push(response.document);
                    }
                })
                .finally(() => this.loadingDocument = false)
        },

        removeDocument(key) {
            this.form.documents.splice(key, 1)
        },
    }
}
</script>

<style scoped>

</style>
